import API from '@/lib/api'
import _ from 'lodash'

const userModule = {
  state: {
    permissions: []
  },
  mutations: {
    SET_PERMISSIONS(state, newVal) {
      state.permissions= newVal
    }
  },
  getters: {
    getPermissions (state) {
      return state.permissions
    },
    hasPermission: (state) => (slug) => {
      console.log(_.find(state.permissions, {slug: slug}))
      return (_.find(state.permissions, {slug: slug})) ? true :false
    }
  },
  actions: {
    async FETCH_PERMISSIONS ({dispatch, commit}) {
      let result = await API.get('/users/me/permissions')
      commit('SET_PERMISSIONS', result.data)
    }
  }
}

export const state = userModule.state
export const getters = userModule.getters
export const mutations = userModule.mutations
export const actions = userModule.actions